import React from "react";
import styles from "./index.module.scss";
import searchIcon from "../../assets/icons/search.svg";

interface ISearchInput {
  className?: string;
  value: string;
  onChangeCallback: (value: string) => void;
  placeholder?: string;
}

export const SearchInput: React.FC<ISearchInput> = ({
  className,
  value,
  onChangeCallback,
  placeholder="Поиск по банкам"
}) => {
  return (
    <div className={`${styles.input_container} ${className}`}>
      <img src={searchIcon} alt="search_icon" />
      <input
        value={value}
        type="text"
        className={styles.input}
        placeholder={placeholder}
        onChange={(e) => {
          onChangeCallback(e.target.value);
        }}
      />
    </div>
  );
};
